import { combineReducers } from 'redux';
import filterReducer from './filterReducer';
import questionnaireReducer from './questionnaireSlice';
import stressLevelReducer from './stressLevelSlice';
import categoryReducer from './categorySlice';
import displayedExpertsReducer from './displayedExpertsSlice';
import languageReducer from './languageSlice';
import modalReducer from './modalSlice';
import userReducer from './userSlice';
import organizationReducer from './organizationSlice';
import activityLogReducer from './activityLogSlice';
import firstAidLogReducer from './firstAidLogSlice';
import mhRiskAssessmentReducer from './mhRiskAssessmentSlice';
import maternityRiskAssessmentReducer from './maternityRiskAssessmentSlice';
import documentReducer from './documentSlice';
import instructionAssignmentsReducer from './instructionAssignmentsSlice';

const rootReducer = combineReducers({
  filter: filterReducer,
  questionnaire: questionnaireReducer,
  stressLevel: stressLevelReducer,
  category: categoryReducer,
  displayedExperts: displayedExpertsReducer,
  language: languageReducer,
  modal: modalReducer,
  user: userReducer,
  organization: organizationReducer,
  activityLog: activityLogReducer,
  firstAidLog: firstAidLogReducer,
  mhRiskAssessment: mhRiskAssessmentReducer,
  maternityRiskAssessment: maternityRiskAssessmentReducer,
  document: documentReducer,
  instructionAssignments: instructionAssignmentsReducer,
});

export default rootReducer;
